import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Company } from '../models/question-detail.model';
import { QuestionCompaniesApi } from '../api/question-companies.api';

@Injectable({ providedIn: 'root' })
export class QuestionCompaniesService {
  private readonly _api = inject(QuestionCompaniesApi);

  public companies(): Observable<Company[]> {
    return this._api.companies();
  }
}
